exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".redirectBox {\n\n    margin: 24px;\n    padding: 24px;\n    border-radius: 16px;\n    border: 1px solid rgb(196, 201, 191);\n}", ""]);

